import { NSARouterMakerResult } from "namirasoft-account-react";
import { ContentTemplateInputRow, ContentTemplateRow } from "namirasoft-content-template";
import { ContentTemplateEntities } from "../ContentTemplateEntities";
import { ContentTemplateProps } from "../ContentTemplateProps";
import { ContentTemplateLayout } from "../ContentTemplateLayout";
import { getContentTemplateParameterTab } from "../components/ContentTemplateParameterList";

export interface ContentListPageProps extends NSARouterMakerResult, ContentTemplateProps { }

function ContentListPage(props: ContentListPageProps)
{
	return (
		<ContentTemplateLayout<ContentTemplateRow, ContentTemplateInputRow>
			{...props}
			action={{
				title: "",
				description: "A list of content templates for easy messaging.",
				menus: {}
			}}
			pages={{
				entity: ContentTemplateEntities.content_template(props),
				list: {
					ui: {
						tab_page_view: { tabs: { extra: { after_general: [getContentTemplateParameterTab()] } } }
					}
				}
			}}
		>
			<></>
		</ContentTemplateLayout>
	);
}

export default ContentListPage;